import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {
  getOptoutData,
  getOuptoutData,
  responseOptoutData,
  getOptoutInternationalData,
  getOuptoutInternationalData,
  responseOptoutInternationalData,
  getOptoutCustomBranding,
} from './EndUserSlice/EndUserSlice'

import './EndUser.css'
import SuccessMessagePage from '../../../Components/SuccessMessagePage'
import StopLinkSuccessPage from '../../../Components/StoplinkSuccessPage'
import {ENV} from '../../../Utils/_helpers/EnvHelper'

const OptOutPage = () => {
  const host = document?.location?.host || ''
  const param = useLocation()

  const dispatch = useDispatch()
  const [isSuccess, setIsSuccess] = useState(false)

  const data = useSelector(getOuptoutData)
  const optoutInternationalData = useSelector(getOuptoutInternationalData)
  const customBranding = useSelector(getOptoutCustomBranding)

  const [formValues, setFormValues] = useState<any[]>([])

  useEffect(() => {
    let code = param.pathname?.split('/').at(-1)
    if (host === ENV().REACT_APP_OPTOUT) {
      dispatch(getOptoutData({url: code}))
    } else {
      dispatch(getOptoutInternationalData({url: code}))
    }
  }, [])

  const optoutData = host === ENV().REACT_APP_OPTOUT ? data : optoutInternationalData
  const isNormalOptOut =
    optoutData?.options?.map((it: any) => Object.values(it).at(0)).filter((it: any) => it)?.length >
    0

  const handleSubmitResponse = () => {
    let code = param.pathname?.split('/').at(-1)

    if (host === ENV().REACT_APP_OPTOUT) {
      dispatch(
        responseOptoutData({
          url: code,
          response: {
            response: isNormalOptOut ? formValues : ['option1'],
          },
        })
      ).then(() => {
        setIsSuccess(true)
      })
    } else {
      dispatch(
        responseOptoutInternationalData({
          url: code,
          response: {
            response: isNormalOptOut ? formValues : ['option1'],
          },
        })
      ).then(() => {
        setIsSuccess(true)
      })
    }
  }

  if (isSuccess) {
    return <StopLinkSuccessPage />
  }

  return (
    <>
      {optoutData || optoutInternationalData ? (
        <div
          style={{backgroundColor: '#f7f8fa'}}
          className='d-flex flex-column text-center justify-content-center inner-content-main OptOutSurvey_Detail'
        >
          {/* Custom Logo */}
          {customBranding.customLogo && (
            <div className='py-5'>
              <img
                src={customBranding.customLogo}
                alt='Company Logo'
                style={{
                  maxWidth: '200px',
                  maxHeight: '100px',
                  objectFit: 'contain',
                }}
              />
            </div>
          )}

          {customBranding.customTitle && (
            <div className='pt-2'>
              <h5>{customBranding.customTitle}</h5>
            </div>
          )}
          <div className='py-10 pt-15'>
            <h4>{`Opt-Out ${isNormalOptOut ? 'Survey' : ''}`}</h4>
          </div>
          <div className=''>
            <p>{optoutData?.description}</p>
          </div>

          <div className='d-flex flex-column w-70 mb-5 checkBox_par'>
            {isNormalOptOut &&
              optoutData?.options?.map((key: any, index: any) => (
                <div key={index} className='landingpage_inside_label'>
                  <label className='w-auto'>
                    <input
                      value={key[`option${index + 1}`]}
                      type='checkbox'
                      onClick={(e: any) => {
                        let find = optoutData?.options?.find(
                          (key: any, index: number) => key[`option${index + 1}`] === e.target.value
                        )
                        let check = formValues.indexOf(Object.keys(find)[0])
                        if (check >= 0) {
                          let data = [...formValues]
                          data.splice(check, 1)
                          setFormValues(data)
                        } else {
                          setFormValues([...formValues, Object.keys(find)[0]])
                        }
                      }}
                    />
                    <span className='text-nowrap text-white'>{key[`option${index + 1}`]}</span>
                  </label>
                </div>
              ))}
          </div>

          {isNormalOptOut && (
            <div className='form-group mb-8'>
              <label className='fs-6 mb-2 d-block' style={{textAlign: 'left'}}>
                What number you'd like to unsub?
              </label>
              <input type='text' className='form-control' placeholder='Enter mobile number here' />
            </div>
          )}

          <button
            disabled={isNormalOptOut && formValues?.length <= 0}
            className='btn btn-lg gray_bg_purple'
            onClick={() => handleSubmitResponse()}
          >
            {isNormalOptOut ? 'Submit and Unsubscribe ' : 'Unsubscribe me'}
          </button>

          {/* Custom Footer */}
          {customBranding.customFooter && (
            <div className='py-5 mt-5'>
              <p className='text-muted fs-7'>{customBranding.customFooter}</p>
            </div>
          )}
        </div>
      ) : (
        <SuccessMessagePage />
      )}
    </>
  )
}

export default OptOutPage
